import React, { useMemo } from 'react';
import { Textarea } from 'baseui/textarea';
import type { TextareaOverrides } from 'baseui/textarea';
import type { EnhancedQuestion, Answer } from '../../types';
import { getErrorMessageFromQuestion, getPlaceholder } from '../../utils';
export type TextareaInputProps = {
  question: EnhancedQuestion;
  answer?: Answer;
  overrides?: TextareaOverrides;
  setAnswerForQuestion: (questionId: string, answers: string[]) => void;
};
const TextareaInput = ({
  question,
  answer,
  overrides,
  setAnswerForQuestion
}: TextareaInputProps) => {
  const value = answer?.answers[0];
  const placeholder: string | undefined = useMemo(() => getPlaceholder(question.tags), [question.tags]);
  const onChange = (e: React.SyntheticEvent<HTMLTextAreaElement>) => {
    // TypeScript, by default, infers event.target as EventTarget, which is a generic interface and does not contain properties like value or checked that are specific to HTML input elements.
    setAnswerForQuestion(question.id, [(e.target as HTMLTextAreaElement).value]);
  };
  return <Textarea overrides={overrides} value={value} placeholder={placeholder} error={!!getErrorMessageFromQuestion(question)}
  // Prevent Alt+S from bubbling to f7-utask's global hotkey listener,
  // which would trigger accidental task submission while typing.
  onKeyDown={(e: React.KeyboardEvent) => {
    if (e.altKey && e.key === 's') {
      e.preventDefault();
      e.stopPropagation();
    }
  }} onChange={onChange} />;
};
export default TextareaInput;